import { useState } from 'react';
import { useApp } from '../context/AppContext';
import { track } from '../analytics';
import type { Flight } from '../types';

export function useFlightEntry() {
  const { currentUser, addFlight, updateFlight } = useApp();
  const [flightNumber, setFlightNumber] = useState('');
  const [date, setDate] = useState('');
  const [error, setError] = useState<string | null>(null);

  // Manual form fields
  const [manualDep, setManualDep] = useState('');
  const [manualArr, setManualArr] = useState('');
  const [manualDepTime, setManualDepTime] = useState('');
  const [manualArrTime, setManualArrTime] = useState('');
  const [aircraftType, setAircraftType] = useState('');

  const saveManual = (): boolean => {
    if (!manualDep || !manualArr || !date) {
      setError('Fill in departure, arrival, and date');
      return false;
    }
    const flight: Flight = {
      id: `flight-${Date.now()}`,
      userId: currentUser.id,
      flightNumber: flightNumber.trim() || `${currentUser.airlineCode} ???`,
      date,
      departureAirport: manualDep.toUpperCase(),
      arrivalAirport: manualArr.toUpperCase(),
      departureTime: manualDepTime || undefined,
      arrivalTime: manualArrTime || undefined,
      airlineCode: currentUser.airlineCode,
      ...(aircraftType ? { aircraftType } : {}),
      source: 'manual',
    };
    addFlight(flight);
    track('flight_added', { source: 'manual', dep: flight.departureAirport, arr: flight.arrivalAirport });
    reset();
    return true;
  };

  const saveEdit = (flightId: string): boolean => {
    if (!manualDep || !manualArr || !date) {
      setError('Fill in departure, arrival, and date');
      return false;
    }
    updateFlight(flightId, {
      flightNumber: flightNumber.trim() || `${currentUser.airlineCode} ???`,
      date,
      departureAirport: manualDep.toUpperCase(),
      arrivalAirport: manualArr.toUpperCase(),
      departureTime: manualDepTime || undefined,
      arrivalTime: manualArrTime || undefined,
      ...(aircraftType ? { aircraftType } : {}),
    });
    reset();
    return true;
  };

  const reset = () => {
    setFlightNumber('');
    setDate('');
    setError(null);
    setManualDep('');
    setManualArr('');
    setManualDepTime('');
    setManualArrTime('');
    setAircraftType('');
  };

  return {
    flightNumber,
    setFlightNumber,
    date,
    setDate,
    error,
    manualDep,
    setManualDep,
    manualArr,
    setManualArr,
    manualDepTime,
    setManualDepTime,
    manualArrTime,
    setManualArrTime,
    aircraftType,
    setAircraftType,
    saveManual,
    saveEdit,
    reset,
  };
}
